export default __webpack_public_path__ + "static/media/icon_popup_qrcode.2f340319.svg";